import React from 'react';
import { Button } from '../../../UI/Elements';

export const BannerButtons = ({ buttons, size }: BannerProps) => (
  <div className='flex justify-center items-start flex-col lg:items-start lg:justify-start lg:flex-row'>
    {buttons?.items?.map((button, index) => (
      <div className={`mt-4 lg:mt-0 ${index !== 0 ? 'lg:ml-4' : ''}`}>
        <Button
          {...button}
          label={{
            ...button.label,
          }}
          icon={{
            ...button?.icon,
            iconKey: 'HiChevronRight',
            color: button.label.color,
            size,
          }}
          size={size}
        />
      </div>
    ))}
  </div>
);

export const Buttons = ({ buttons }: BannerProps) => (
  <div className='w-full flex mb-4 lg:mb-0 lg:justify-center'>
    <BannerButtons
      buttons={buttons}
      size='lg'
    />
  </div>
);
